import { IonItem, IonLabel, IonSegment, IonSegmentButton, IonToggle } from '@ionic/react'
import React, { useContext, useState } from 'react'
import { ConfigContext } from '../../contexts/ConfigContext';

let min = 1000 * 60;
let hr = 60 * min;
let day = 24 * hr;

let duration = [day, 7 * day, 15 * day, 30 * day]

const ScheduleBackup = ({ user }) => {

    const { Config, setConfig } = useContext(ConfigContext);
    const [BackupSchedule, setBackupSchedule] = useState(Config.scheduledBackup.enabled);
    const [scheduleDuration, setScheduleDuration] = useState(Config.scheduledBackup.duration);

    const updateScheduleDuration = duration => {
        console.log(duration);
        Config.scheduledBackup.duration = parseInt(duration);
        setConfig(Config);
    };

    const scheduleToggle = (e) => {
        console.log(e);
        Config.scheduledBackup.enabled = e;
        setConfig(Config);
    }

    return (
        <>
            <IonItem hidden={!user}>
                <IonLabel>Scheduling Enabled</IonLabel>
                <IonToggle checked={BackupSchedule} onIonChange={() => {
                    setBackupSchedule(!BackupSchedule)
                    scheduleToggle(!BackupSchedule)
                    if (BackupSchedule) {
                        updateScheduleDuration(day);
                    }
                }} />
            </IonItem>
            <IonSegment hidden={!BackupSchedule} color='danger' value={scheduleDuration} onIonChange={e => {
                if (BackupSchedule) {
                    setScheduleDuration(e.detail.value)
                    updateScheduleDuration(e.detail.value)
                }
            }}>
                {
                    duration.map((i, index) => (
                        <IonSegmentButton key={index} value={i}>
                            <IonLabel>{i / day} Days</IonLabel>
                        </IonSegmentButton>
                    ))
                }
            </IonSegment>
        </>
    )
}

export default ScheduleBackup

